// extracted by mini-css-extract-plugin
module.exports = {"container":"Crossbox_container__2L5h6","checkbox":"Crossbox_checkbox__1gJcU","icon":"Crossbox_icon__-Mc47","row":"Crossbox_row__2h0TN","label":"Crossbox_label__1bl1z"};